import React, { useEffect } from "react";
import { Link, NavLink } from "react-router";
import { CartProvider, useCart } from "react-use-cart";
import AOS from "aos";
import "aos/dist/aos.css"; 
import Footer from "../Components/Footer";

function Cart() {
   useEffect(() => {
      AOS.init({ duration: 700 }); 
    }, []);
  const {
    emptyCart,
    isEmpty,
    items,
    updateItemQuantity,
    removeItem,
    totalItems,
    cartTotal,
  } = useCart();
  if (isEmpty)
    return (
      <p
        className="text-center"
        style={{
          fontSize: "35px",
          color: "gray",
          fontWeight: "700",
          letterSpacing: "2px",
          paddingBottom: "8px",
        }}
      >
        <br></br>
        <br></br>Your cart is empty
      </p>
    );
   

  return (
    <>
      <div className="untree_co-section before-footer-section">
        <div className="container">
          <div className="row mb-5">
            <form className="col-md-12" method="post">
              <div className="site-blocks-table">
                <br></br>
                <br></br>
                <table className="table">
                  <thead>
                    <tr>
                      <th className="product-thumbnail">Image</th>
                      <th className="product-name">Product</th>
                      <th className="product-price">Price</th>
                      <th className="product-quantity">Quantity</th>
                      <th className="product-total">Total</th>
                      <th className="product-remove">Remove</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item) => (
                      <tr key={item.id}  data-aos="fade-out">
                        <td className="product-thumbnail">
                          <img
                            style={{ width: "110px" }}
                            src={item.images[0]}
                            alt="88"
                          ></img>
                        </td>
                        <td className="product-name">
                          {" "}
                          <h2 className="h5 text-black">{item.title}</h2>
                        </td>
                        <td>{Math.round(item.price)}</td>
                        <td>
                          <div
                            className="input-group mb-3 d-flex align-items-center quantity-container"
                            style={{ maxWidth: 120 }}
                          >
                            <div className="input-group-prepend">
                              <button
                                className="btn btn-outline-black decrease"
                                type="button"
                                onClick={() =>
                                  updateItemQuantity(
                                    item.id,
                                    (item.quantity ?? 0) - 1
                                  )
                                }
                              >
                                −
                              </button>
                            </div>
                            <input
                              type="text"
                              className="form-control text-center quantity-amount"
                              defaultValue={1}
                              value={item.quantity}
                              placeholder=""
                              aria-label="Example text with button addon"
                              aria-describedby="button-addon1"
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-black increase"
                                type="button"
                                onClick={() =>
                                  updateItemQuantity(
                                    item.id,
                                    (item.quantity ?? 0) + 1
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </td>

                        <td>{Math.round(item.price * item.quantity)}</td>

                        <td>
                          <button
                            className="btn btn-primary m-1"
                            onClick={() => removeItem(item.id)}
                          >
                            &times;
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="row mb-5">
                <div className="col-md-6 mb-3 mb-md-0">
                  <button
                    className="btn btn-black btn-sm btn-block"
                    onClick={emptyCart}
                  >
                    Clear All
                  </button>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/shop"
                    className="btn btn-outline-black btn-sm btn-block"
                  >
                    Continue Shopping
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 pl-5">
              <div className="row justify-content-end">
                <div className="col-md-7">
                  <div className="row">
                    <div className="col-md-12 text-right border-bottom mb-5">
                      <h3 className="text-black h4 text-uppercase">
                        Cart Totals
                      </h3>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <span className="text-black">Total Products</span>
                    </div>
                    <div className="col-md-6 text-right">
                      <strong className="text-black">{totalItems}</strong>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-6">
                      <span className="text-black">Total</span>
                    </div>
                    <div className="col-md-6 text-right">
                      <strong
                        className="text-black"
                        style={{ fontSize: "18px", color: "red" }}
                      >
                        {Math.round(cartTotal)} $$
                      </strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <NavLink
                        to="/check"
                        className="btn btn-black btn-lg py-3 btn-block"
                        onclick="window.location='checkout.html'"
                      >
                        Proceed To Checkout
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
function Pasket() {
  return (
    <CartProvider>
      <Cart />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Footer />
    </CartProvider>
  );
}

export default Pasket;
